import { SocieteConfigAnalyseSyntheseState } from '@get/store/states';
import { Action, createReducer } from '@ngrx/store';
import { societeConfigAnalyseSyntheseReducersGeneratedFunctions } from './societe-config-analyse-synthese-generated.reducer';

const societeConfigAnalyseSyntheseReducersFunctions = [...societeConfigAnalyseSyntheseReducersGeneratedFunctions];

const societeConfigAnalyseSyntheseReducer = createReducer(
  SocieteConfigAnalyseSyntheseState.initialState,
  ...societeConfigAnalyseSyntheseReducersFunctions
);

export function reducer(state: SocieteConfigAnalyseSyntheseState.IState | undefined, action: Action) {
  return societeConfigAnalyseSyntheseReducer(state, action);
}
